import { render, staticRenderFns } from "./ProductFormPage.vue?vue&type=template&id=d7ad4c22&scoped=true&"
import script from "./ProductFormPage.vue?vue&type=script&lang=ts&"
export * from "./ProductFormPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductFormPage.vue?vue&type=style&index=0&id=d7ad4c22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ad4c22",
  null
  
)

export default component.exports